import React from 'react';
import './FooterComponent.css';
import {useNavigate} from "react-router-dom";
function FooterComponent() {
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione

    const goToSection = (id) => {
        navigate('/#'+id)
    };
    return (
            <footer className="d-flex flex-wrap justify-content-between align-items-center p-3 border-top"><p
                className="col-md-4 mb-0 text-body-secondary">© 2025 CiSono, Inc</p>
                <a href="/" className="col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto
                link-body-emphasis text-decoration-none" aria-label="Bootstrap">
                {/*<svg className="bi me-2" width="40" height="32" aria-hidden="true">*/}
                {/*    <use xlinkHref="#bootstrap"></use>*/}
                {/*</svg>*/}
                    <img src="/logo.png" width="100" alt="" className="p-3"/>

                </a>
                <ul className="nav col-md-4 justify-content-end">
                    <li className="nav-item"><a href="#" className="nav-link px-2 text-body-secondary">Home</a></li>
                    <li className="nav-item"><a onClick={() => {goToSection('prezzi')} } className="nav-link px-2 text-body-secondary">Prezzi</a></li>
                    <li className="nav-item"><a onClick={() => {goToSection('chisiamo')} } className="nav-link px-2 text-body-secondary">Chi non Siamo</a></li>
                    <li className="nav-item"><a href="/privacy-policy" className="nav-link px-2 text-body-secondary">Privacy Policy</a></li>
                </ul>
            </footer>
    );
}

export default FooterComponent;
